<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  data() {
    let beforeLabel = this.labelBeforeValue;
    let afterLabel = this.labelAfterValue;
    return {
      chart_options: {
        /* backgroundColor: "red", */
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return beforeLabel + value + afterLabel;
                },
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: {},
    };
  },
  mounted() {
    this.fetchDatas();
    // Overwriting base render method with actual data.
  },
  methods: {
    changeUrl(newUrl) {
      this.url = newUrl;
      this.fetchDatas();
    },

    fetchDatas() {
      axios.get(this.url).then((response) => {
        this.datas = response.data;
        this.renderChart(this.datas, this.chart_options);
      });
    },
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    labelBeforeValue: {
      type: String,
      required: false,
      default: "",
    },
    labelAfterValue: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
